export default __webpack_public_path__ + "static/latitude-scam-alert-2-fbd64e70c59a3bd8cab7a84688adeb59.webp";